import WebApp from "@twa-dev/sdk";
import type { WebAppInitData } from "@twa-dev/types";

export function webAppUserGet(): WebAppInitData["user"] | undefined {
  return WebApp.initDataUnsafe.user;
}
